/*
 * @Author: your name
 * @Date: 2019-11-14 10:11:49
 * @LastEditTime: 2020-08-17 14:18:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_pc\src\main.js
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueLazyLoad from "vue-lazyload";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "es6-promise/auto";
import api from "./api/index";
import common from "./utils/common";
import $ from "jquery";

Vue.config.productionTip = true;
Vue.prototype.$api = api;
Vue.prototype.$common = common
/* eslint-disable no-new */
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
}); //回到顶部

Vue.use(ElementUI);
import store from "./vuex/store";

Vue.use(VueLazyLoad, {
  error: "/static/imgout1.png",
  // loading:'/static/imgout2.png',
  filter: {
    // index(listener, opts) {
    //   listener.src=listener.src.replace('/n0/','/n1/')
    // }
  }
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js